import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { OverviewMapComponent } from './overview-map.component';

@NgModule({
  imports: [CommonModule],
  declarations: [OverviewMapComponent],
  exports: [OverviewMapComponent],
})
export class OverviewMapModule {}
